export const CASINO_ELEMENT_NAMES = [
  'CasinoCategories',
  'CasinoProviders',
  'CasinoGames'
];
export const NEED_MOUNTED_ONE_ELEMENTS = ['Accounts'];

export const FAVORITE = 'favorite';
export const PERSONALIZATION = 'personalization';
